import * as actionTypes from '../actionTypes';

const initialState = {
	features: [],
};

function reducer(state = initialState, action) {
	switch (action.type) {
		case actionTypes.GET_FEATURES_SUCCEED:
			return {
				...state,
				features: action.payload
			};
		default:
			return state;
	}
}


export default reducer;
